/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import { format } from 'date-fns'
// import moment from 'moment'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Button from 'components/Button'
import Dialog from 'components/Dialog'
import constants from 'constants'
import { IconCheck, IconCross } from 'icons'

const styles = Object.assign(
  {},
  require('./FeatureToggleList.scss'),
  { columns: require('../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class FeatureToggleList extends Component {
  static propTypes = {
    header: PropTypes.string,
    featureToggle: PropTypes.object,
    featureToggleItems: PropTypes.instanceOf(Array),
    editFeatureToggle: PropTypes.func.isRequired,
  }
  static defaultProps = {
    featureToggle: null,
    featureToggleItems: {},
    header: '',
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDialogOpen: false,
      submit: false,
      itemSelected: '',
    }
  }
  _openConfirmDialog = (item) => {
    this.setState({ confirmDialogOpen: true })
    this.setState({ itemSelected: item })
  }

  _closeConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false })
  }

  _saveConfirmDialog = () => {
    this.setState({
      confirmDialogOpen: false,
      submit: true,
    })
    this.props.editFeatureToggle(this.state.itemSelected)
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.description, headerStyles)}>
          Feature name
        </th>
        <th className={(styles.columns.created, headerStyles)}>Feature enabled</th>
        <th className={(styles.columns.created, headerStyles)}>Last modified</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.featureToggleItems.length ? (
      this.props.featureToggleItems.map((itm, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.base} key={`${itm.feature_id}-${i}`}>
          <td className={styles.featurename}>
            {itm.feature_name}
          </td>
          <td>{itm.is_enabled ? <IconCheck className={styles.icon} /> : <IconCross className={styles.crossIcon} />}</td>
          <td>{itm.time_stamp ? format(new Date(itm.time_stamp), constants.DATE_FORMAT.PARTNER_PLAN_LIST) : ''}</td>
          <td>
            <Button
              className={classnames(itm.is_enabled ? styles.buttonGrayBorder : styles.buttonGreenBorder)}
              onClick={() => {
                this._openConfirmDialog(itm)
              }}
              type="flat"
            >
              {itm.is_enabled ? 'Disable Feature' : 'Enable Feature'}
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noRecord}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    const { confirmDialogOpen, itemSelected } = this.state

    const isEnabled = itemSelected.is_enabled
    const featureName = itemSelected.feature_name || 'this feature'

    const dialogTitle = isEnabled ? 'Disable Feature?' : 'Enable Feature?'
    const dialogMessage = isEnabled
      ? `Are you sure you want to disable "${featureName}"?\n\nThis will make it unavailable to partners. You can re-enable it at any time.`
      : `Do you want to enable "${featureName}"?\n\nOnce enabled, partners will have access to it immediately.`

    const dialogProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDialog },
        { label: 'CONFIRM', onClick: this._saveConfirmDialog },
      ],
      title: dialogTitle,
      active: confirmDialogOpen,
      onClose: this._closeConfirmDialog,
      children: (
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {dialogMessage}
        </div>
      ),
    }

    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
        <Dialog {...dialogProps} />
      </div>
    )
  }
}

export default FeatureToggleList



// WEBPACK FOOTER //
// ./src/views/FeatureToggle/components/FeatureToggleList.js